// developed by Param Partap Singh
import React, {useState} from 'react'
import Nav from "../Utils/Nav"
import { Link } from 'react-router-dom';
import "../Css/About.css"
import mudasir from "../Assets/Mudasi.png"
import sam from "../Assets/sam.jpg"
import basant from "../Assets/basant.jpg"
import sujata from "../Assets/sujata_Pal.jpeg"
import jagpreet from "../Assets/jagpreet.png"
import dummy from "../Assets/dummy.jpg"
import vikram from "../Assets/vikram.jpg"
import manvender from "../Assets/manvender.png"
import pooja from "../Assets/pooja.jpg"
import banner from "../Assets/background2.JPG";
import Footer from '../Utils/Footer';


export default function About() {
  const audioVideoTeam = [
    {
      id: 1,
      name: 'Parmod Kumar',
      position: 'Technical Assistant',
      email: 'staff.parmod.kumar@iitrpr.ac.in',
      phone: '01881-235115',
      image: `${process.env.PUBLIC_URL}/Images/Team/Parmod Kumar.jpg`
    },
    {
      id: 2,
      name: 'Anuj Mishra',
      position: 'Junior Technical Assistant',
      email: 'staff.anuj.mishra@iitrpr.ac.in',
      phone: '01881-235115',
      image: `${process.env.PUBLIC_URL}/Images/Team/Anuj image - Anuj Mishra.jpg`
    },
    {
      id: 3,
      name: 'Vikash Chaudhary',
      position: 'Junior Technical Assistant',
      email: 'staff.vikash.chaudhary@iitrpr.ac.in',
      phone: '01881-XXXXXX',
      image: `${process.env.PUBLIC_URL}/Images/Team/Vikash Chaudhary.jpeg`
    },
    {
      id: 4,
      name: 'Raghuvir',
      position: 'Junior Technical Assistant',
      email: 'staff.raghuvir@iitrpr.ac.in',
      phone: '01881-235115',
      image: `${process.env.PUBLIC_URL}/Images/Team/Raghuvir.jpg`
    }
  ];

  return (
   <>
   <Nav/>
   <div className="about-main">
        <div className="banner" style={{marginTop:"20px"}}>
            <img className="background" src={banner} alt="" />
        <h1 className="main-heading-title">About Us</h1>
        </div>

        <div className="page-content">
          <p>
          <b>Address:</b> 104, NOC Room, S.Ramanujan Block, IIT Ropar, Rupnagar Punjab- 140001 India <br/><br/> <b>IT Team Email:</b> <a href="mailto:itteam@iitrpr.ac.in" style={{textDecoration:"none", color:"#10386b", cursor:"pointer"}}>itteam@iitrpr.ac.in</a>
          </p>
        </div>

        <div className="about">
             


          <div className="left-about-content">
              
               {/* --------------Faculty------------------ */}

            <div className="about-content">
            
              <h1>IT Committee</h1>

              <div className="headofdep">
                <div className="hod">
                  <img src={mudasir} alt="" />
                  <div className="hod-content">
                    <p> Dr. Mudasir Ahmed</p>
                    <strong>Chairperson</strong> 
                  </div>
                </div>
                
                <div className="hod">
                  <img src={sam} alt="" />
                  <div className="hod-content">
                    <p> Dr. Sam Darshi</p>
                    <strong>Vice-Chairman</strong> 
                  </div>
                </div>



              </div>
             
              <h2 className='dept-people-headng'>Committee Members</h2>
              <div className="grid-dpt-people">
                
                   <div className="dep-faculty">
                       <img src={basant} alt="" />
                       <div className="dep-faculty-content">
                         <p>Dr. Basant Subba</p>
                         <strong>Member</strong> 
                       </div>
                    </div>               
                
                   <div className="dep-faculty">
                       <img src={sujata} alt="" />
                       <div className="dep-faculty-content">
                         <p>Dr. Sujata Pal</p>
                         <strong>Member</strong> 
                       </div>
                    </div>               
                
                   <div className="dep-faculty">
                       <img src={jagpreet} alt="" />
                       <div className="dep-faculty-content">
                         <p>Dr. Jagpreet Singh</p>
                         <strong>Member</strong> 
                       </div>
                    </div>               
                 
              </div>


              <h2 className='dept-people-headng'>IT Team</h2>
              <div className="grid-dpt-people">
{/*                 
                   <div className="dep-faculty">
                       <img src={dummy} alt="" />
                       <div className="dep-faculty-content">
                         <p>Mr. Ashutosh Kumar</p>
                         <strong>Senior Technical Officer</strong>
                         <strong>sto.it@iitrpr.ac.in</strong>
                         <strong>01881-235126</strong>
                       </div>
                    </div>    */}

                     <div className="dep-faculty">
                       <img src={dummy} alt="" />
                       <div className="dep-faculty-content">
                         <p>Mr. Hoshang Verma</p>
                         <strong>Technical Officer</strong>
                         <strong>to.it@iitrpr.ac.in</strong>
                         <strong>01881-235151</strong>
                       </div>
                    </div>                
                
                   <div className="dep-faculty">
                       <img src={vikram} alt="" />
                       <div className="dep-faculty-content">
                         <p>Mr.Vikram Singh Shekhawat</p>
                         <strong>Junior Technical Superintendent</strong> 
                         <strong>jts.it@iitrpr.ac.in</strong> 
                         <strong>01881-235134</strong>
                       </div>
                    </div>               
                
                   <div className="dep-faculty">
                       <img src={manvender} alt="" />
                       <div className="dep-faculty-content">
                         <p>Mr. Manvender Singh</p>
                         <strong>Senior Lab Assistant</strong>
                         <strong>manvender.singh@iitrpr.ac.in</strong> 
                         <strong>01881-235119</strong> 
                       </div>
                    </div>               
                
                   <div className="dep-faculty">
                       <img src={pooja} alt="" />
                       <div className="dep-faculty-content">
                         <p>Mrs. Pooja Pandey</p>
                         <strong>Senior Lab Assistant</strong> 
                         <strong>pooja.pandey@iitrpr.ac.in</strong> 
                         <strong>01881-235116</strong>
                       </div>
                    </div>               
                
                   <div className="dep-faculty">
                       <img src={dummy} alt="" />
                       <div className="dep-faculty-content">
                         <p>Ms. Ramanpreet Kaur</p>
                         <strong>Junior Lab Assistant</strong>
                         <strong>ramanpreet.kaur@iitrpr.ac.in</strong> 
                         <strong>91-1881-235223</strong> 
                       </div>
                    </div>               
                
                   {/* <div className="dep-faculty">
                       <img src={dummy} alt="" />
                       <div className="dep-faculty-content">
                         <p>Mr. Ankit Kumar Gupta</p>
                         <strong>Junior Lab Assistant</strong>
                         <strong>ankit.gupta@iitrpr.ac.in</strong> 
                         <strong>01881-235133</strong> 
                       </div>
                    </div>                */}
                
              </div>

              <h2 className='dept-people-headng'>Office Staff</h2>
              <div className="grid-dpt-people">
                
                   <div className="dep-faculty">
                       <img src={dummy} alt="" />
                       <div className="dep-faculty-content">
                         <p style={{textAlign:"center"}}>IT Office</p>
                         <strong>office.it@iitrpr.ac.in</strong>
                         <strong>01881-235115</strong>
                       </div>
                    </div>               
            
                   </div>

              <h2 className='dept-people-headng'>Audio Video Team</h2>
              <div className="grid-dpt-people">
                {audioVideoTeam.map((member) => (
                   <div className="dep-faculty" key={member.id}>
                       <img src={member.image} alt={member.name} />
                       <div className="dep-faculty-content">
                         <p style={{textAlign:"center"}}>{member.name}</p>
                         <strong>{member.position}</strong> 
                         <strong>{member.email}</strong>
                         <strong>{member.phone}</strong>
                       </div>
                    </div>
                ))}
              </div>


            </div>

          
           


          </div>
        </div>
      </div>
  
  <Footer/>

   
   </>
  )
}
